import { Dispatch } from "react";
import API from "../../services/api";
import { Template } from "typings";

export interface LoadTemplatesAction
{
    type: "LOAD_TEMPLATES";
}

const loadTemplates_ = (): LoadTemplatesAction => ({ 
    type: "LOAD_TEMPLATES" 
});

export interface LoadTemplatesSuccessAction
{
    type: "LOAD_TEMPLATES_SUCCESS";
    templates: Template[];
}

export const loadTemplatesSuccess = (templates: Template[]): LoadTemplatesSuccessAction => ({
    type: "LOAD_TEMPLATES_SUCCESS",
    templates
});

export interface LoadTemplatesFailureAction
{
    type: "LOAD_TEMPLATES_FAILURE";
    error: number;
}

export const loadTemplatesFailure = (error: number): LoadTemplatesFailureAction => ({
    type: "LOAD_TEMPLATES_FAILURE",
    error
});


export const loadTemplates = () => async (dispatch: Dispatch<any>) =>
{
    dispatch(loadTemplates_());
    try 
    {
        const templates = await API.template.fetchAll();
        dispatch(loadTemplatesSuccess(templates));
    }
    catch (e)
    {
        dispatch(loadTemplatesFailure(e));
    }
};


// WEBPACK FOOTER //
// ./src/state/schema/action.ts